import React from 'react';
import { useTranslation } from 'react-i18next';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import HoverComponent from '../../../_partials/HoverComponent/HoverComponent';
import { useSubmitMenuItem } from '../../../useSubmitMenuItem';
var SubmitMenuItem = function (_a) {
    var className = _a.className, hoverComponentClassName = _a.hoverComponentClassName, type = _a.type, modalType = _a.modalType, modalOptions = _a.modalOptions, label = _a.label, link = _a.link, target = _a.target, verificationAction = _a.verificationAction, showDaProtect = _a.showDaProtect, isNew = _a.isNew, isLegacyHeader = _a.isLegacyHeader, role = _a.role;
    var t = useTranslation().t;
    var _b = useSubmitMenuItem({
        modalType: modalType,
        link: link,
        verificationAction: verificationAction,
        type: type,
        modalOptions: modalOptions,
        isLegacyHeader: isLegacyHeader,
    }), onClick = _b.onClick, href = _b.href, biData = _b.biData;
    return (React.createElement(PlainButtonOrLink, { className: className, href: href, target: target, tabIndex: 0, onClick: onClick, biData: biData, isFakeButton: !onClick, role: role },
        t(label),
        React.createElement(HoverComponent, { svg: type, title: t("".concat(label, ".title")), context: t("".concat(label, ".context")), className: hoverComponentClassName, isNew: isNew, showDaProtect: showDaProtect })));
};
SubmitMenuItem.displayName = 'SubmitMenuItem';
export default SubmitMenuItem;
//# sourceMappingURL=SubmitMenuItem.js.map